/*
 * @Author: bill
 * @Date: 2023-03-14 09:07:18
 * @LastEditors: wangzijun@bzstech.com wangzijun@bzstech.com
 * @LastEditTime: 2024-05-22 09:25:47
 * @FilePath: /study/src/store/index.ts
 * @Description: 
 */
import {configureStore, ThunkAction, Action} from "@reduxjs/toolkit";

import RootReducer from './modules/base'
import ClassificationReducer from './modules/classification'

const store = configureStore({
    reducer: {
        RootReducer,
        ClassificationReducer
    }
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;


export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;

export default store;
